import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '1',
  emoji: '📥',
  title: 'Download Instantly',
  description: 'Get immediate access to all PDF materials right after purchase.'
}, {
  number: '2',
  emoji: '🖨️',
  title: 'Print at Home',
  description: 'Use any home printer. Works beautifully in color or black & white.'
}, {
  number: '3',
  emoji: '🎮',
  title: 'Play & Learn Together',
  description: 'Start with any game. Watch their emotional skills grow naturally.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-24 bg-cream relative overflow-hidden" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-209">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-dark" data-id="element-210">
            Ready in 3 Simple Steps
          </h2>
        </motion.div>

        <div className="relative" data-id="element-211">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-1 bg-secondary/20 rounded-full z-0" data-id="element-212"></div>

          <div className="grid md:grid-cols-3 gap-12 md:gap-8 relative z-10" data-id="element-213">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-214">
                <div className="relative mb-8" data-id="element-215">
                  <div className="w-24 h-24 bg-white rounded-full shadow-lg flex items-center justify-center text-4xl border-4 border-mint relative z-10" data-id="element-216">
                    {step.emoji}
                  </div>
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-secondary text-white rounded-full flex items-center justify-center font-bold text-sm z-20 shadow-md" data-id="element-217">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-2xl font-heading font-bold text-dark mb-3" data-id="element-218">
                  {step.title}
                </h3>
                <p className="text-muted text-lg max-w-xs" data-id="element-219">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}